import { ref } from 'vue';

export function useDealersSorter() {
    const dealers = ref([]);

    function degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }

    function haversineDistance(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = degreesToRadians(lat2 - lat1);
        const dLon = degreesToRadians(lon2 - lon1);
        const a = 
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) * 
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    function sortDealersByProximity(pointLat, pointLong) {
        dealers.value = dealers.value.map(dealer => ({
            ...dealer,
            distance: haversineDistance(pointLat, pointLong, dealer.lat, dealer.long)
        }));
        return dealers.value.sort((a, b) => a.distance - b.distance);
    }

    return { dealers, sortDealersByProximity };
}